<p-toast></p-toast>
<div>
    <p-card styleClass="p-card-shadow">
        <div class="card grid">
            <div class="col-12 md:col-3">
            </div>
            <div class="col-12 md:col-6">
                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center col-12 md:col-6">
                        <p-dropdown (onChange)="onApplicationTypeSelected($event)" [options]="dropDownList"
                            placeholder="{{'SELECT_APPLICATION_TYPE' | translate}}" optionLabel="type" [(ngModel)]="applicationSelected"
                            [disabled]="xslxToJsonData?.length > 0">
                        </p-dropdown>
                    </div>
                    <div class="flex align-items-center justify-content-center col-12 md:col-6">
                        <p-fileUpload [disabled]="!applicationSelected" accept=".xlsx" #fileUpload [customUpload]="true"
                            (uploadHandler)="onUpload($event, 'farmersPhotoPath', fileUpload)" name="myfile[]"
                            mode="basic" [maxFileSize]="5000000" chooseLabel="{{'BROWSE' | translate}}" [auto]="true">
                        </p-fileUpload>
                        <button *ngIf="xslxToJsonData?.length" pButton pRipple type="button" label="{{'VIEW_DOC' | translate}}"
                            class="p-button-text" (click)="onOpenDialog()"></button>
                        <button *ngIf="xslxToJsonData?.length" pButton pRipple type="button" icon="pi pi-trash" pTooltip="{{'DELETE_FILE' | translate}}"
                            class="p-button-rounded p-button-danger p-button-text" (click)="clearUpload()"></button>
                    </div>
                </div>
                <div class="mt-4 red" *ngIf="xslxToJsonData?.length">
                    ( {{'IN_TOTAL_THERE_ARE' | translate}} {{xslxToJsonData?.length}} {{'ROWS_IN_SELECTED_DOCUMENT' | translate }} )
                </div>
                <div class="flex justify-content-center flex-wrap card-container mt-8">
                    <div class="flex align-items-center justify-content-center">
                        <button [disabled]="!applicationSelected" pButton pRipple label="{{'SUBMIT' | translate}}" icon="pi pi-upload"
                            class="p-button-help" (click)="submitApplication()"></button>
                    </div>
                </div>
            </div>
        </div>

    </p-card>
</div>


<p-dialog [(visible)]="showViewDocDialog" [modal]="true" [style]="{margin : '3rem', width: '100%', height: '80%'}"
    [maximizable]="true" [draggable]="false" [resizable]="true" (onHide)="onCloseDialog()">
    <p-table [columns]="cols" [value]="xslxToJsonData" responsiveLayout="scroll">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>
                <td *ngFor="let col of columns">
                    {{rowData[col.field]}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>